// No-op module to safely replace redundant core-js polyfills on modern browsers (e.g. Number.parseFloat on Wix)
var safeParseFloat = (typeof Number !== 'undefined' && Number.parseFloat) || (typeof parseFloat !== 'undefined' ? parseFloat : undefined);
module.exports = safeParseFloat;
